import React from 'react';
import styled from 'styled-components';
import Theme from '../../Theme';
import Calendar from '../../Components/Calendar/product.js';
import useDocuments from '../../Hooks/useDocuments';
import * as Ant from 'antd';
import Breadcrumb from '../../Components/Breadcrumb';
import {ArrowRightOutlined, ArrowLeftOutlined} from '@ant-design/icons';

export default function ProductCalendar(props) {
  const [YM, setYM] = React.useState({
    year: new Date().getFullYear(),
    month: new Date().getMonth(),
  });

  const maxYear = new Date().getFullYear() + 1;
  const minYear = maxYear - 10;
  const years = [];
  let y = maxYear;
  while (y >= minYear) {
    years.push(y--);
  }
  const {records, total, refresh, filters, setFilters} = useDocuments({
    collection: 'product',
    defaultFilters: {
      public: '行事曆',
      limit: 100,
      start_date: {
        $gte: new Date(YM.year, YM.month, 1).toLocaleDateString('sv'),
        $lte: new Date(YM.year, YM.month + 1, 0).toLocaleDateString('sv'),
      },
      $or: [
        {end_date: {$ne: true}},
        {
          end_date: {
            $gte: new Date(YM.year, YM.month, 1).toLocaleDateString('sv'),
            $lte: new Date(YM.year, YM.month + 1, 0).toLocaleDateString('sv'),
          },
        },
      ],

      // category: params.cat,
    },
  });

  React.useEffect(() => {
    refresh();
  }, [refresh]);

  React.useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      start_date: {
        $gte: new Date(YM.year, YM.month, 1).toLocaleDateString('sv'),
        $lte: new Date(YM.year, YM.month + 1, 0).toLocaleDateString('sv'),
      },
      $or: [
        {end_date: {$ne: true}},
        {
          end_date: {
            $gte: new Date(YM.year, YM.month, 1).toLocaleDateString('sv'),
            $lte: new Date(YM.year, YM.month + 1, 0).toLocaleDateString('sv'),
          },
        },
      ],
    }));
  }, [YM]);

  return (
    <Wrapper>
      <main className="tda-layout">
        <section className="content">
          <div className="tda-header third-color">
            <h2>行事曆</h2>
            <Breadcrumb />
          </div>

          <section>
            <Calendar
              year={YM.year}
              month={YM.month}
              products={records}
              setSelectedDt={(value) => console.log('onClick', value)}
              onClickPrev={setYM}
              onClickNext={setYM}
              renderMonthHeader={({month, year, onChange, onPrev, onNext}) => (
                <div className="filter-section">
                  <Ant.Button
                    type="primary"
                    icon={<ArrowLeftOutlined />}
                    onClick={() => onPrev({year, month})}
                  />
                  <div style={{flex: 1}} />
                  <Ant.Select
                    value={year}
                    onChange={(value) => {
                      onChange({year: value, month});
                    }}>
                    {years.map((year) => (
                      <Ant.Select.Option key={year} value={year}>
                        {year}
                      </Ant.Select.Option>
                    ))}
                  </Ant.Select>
                  <div>年</div>
                  <Ant.Select
                    value={month}
                    onChange={(value) => {
                      onChange({month: value, year});
                    }}>
                    {Array.from(Array(12).keys()).map((month) => (
                      <Ant.Select.Option key={month} value={month}>
                        {month + 1}
                      </Ant.Select.Option>
                    ))}
                  </Ant.Select>
                  <div>月</div>
                  <Ant.Button
                    type="primary"
                    onClick={() => {
                      onChange({
                        year: new Date().getFullYear(),
                        month: new Date().getMonth(),
                      });
                    }}>
                    本月
                  </Ant.Button>
                  <div style={{flex: 1}} />
                  <Ant.Button
                    type="primary"
                    icon={<ArrowRightOutlined />}
                    onClick={() => onNext({year, month})}
                  />
                </div>
              )}
            />
          </section>
        </section>
      </main>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: var(--topNavBarHeight);
  min-height: var(--contentMinHeight);
  background-color: var(--primaryBgcolor);

  .filter-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    flex-grow: 0.5;
  }

  @media (max-width: ${Theme.breakpoint}px) {
    .filter-section {
      gap: 2px;
    }
  }
`;
